<mat-toolbar class="header-color">
    <mat-toolbar-row>
      <span> Extra Deliveries </span>
      <span class="example-spacer"></span>
      <button class="btn button" (click)="onAddDelivery()"  mat-fab extended>
        <mat-icon>add</mat-icon>
        Add Delivery
      </button>
      <button class="btn button" (click)="import()">
        Import
      </button>
    </mat-toolbar-row>
    <ng-template #productLabel>
      <mat-toolbar-row>
        <span> Products </span>
      </mat-toolbar-row>
    </ng-template>
  
  </mat-toolbar>

<app-table-standard-layout [dataSource$]="dataSource$" [title]="'Extra deliveries'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings"></app-table-standard-layout>